import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
// Import JSX Modules
import FilterSelectorsMixin from './filter-selectors-mixin';

// -----------------------------------------------------------
//  FilterColorCriteron
// -----------------------------------------------------------
const FilterColorCriteron = createReactClass({
  mixins: [FilterSelectorsMixin],
  render() {
    const label = this.props.title.toLowerCase();

    return (
      <button
        className={classNames('btn selector square', { selected: this.props.selected, disabled: this.props.disabled })}
        ref='option'
        aria-disabled={this.props.disabled}
        aria-label={label}
        aria-pressed={this.props.selected}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleSelected}
      >
        <div className="selector-colour" style={{ background: label }} />
        {this.disabledOverlay()}
      </button>
    );
  }
});

export default FilterColorCriteron;
